@if (label()) {
  <label class="input-main-label">{{ label() }}</label>
}
<div class="inline-input-field">
  <ng-content />
  <mat-form-field
    class="input-main"
    [ngClass]="[sizeClass(), fieldClass()]"
    appearance="outline"
  >
    @if (mask(); as mask) {
      <input
        type="{{ type() }}"
        (blur)="onBlur()"
        [formField]="field"
        [mask]="mask.mask"
        [shownMaskExpression]="mask.placeholder"
        #input
        autocomplete="off"
        matInput
        placeholder="{{ placeholder() }}"
      />
    } @else {
      <input
        type="{{ type() }}"
        (blur)="onBlur()"
        [formField]="field"
        #input
        autocomplete="off"
        matInput
        placeholder="{{ placeholder() }}"
      />
    }
    @if (field().invalid()) {
      <mat-icon matSuffix>report</mat-icon>
    }
    <mat-error>Input is not valid</mat-error>
  </mat-form-field>
</div>
